/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_sci_plot_save_dataset = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Save dataset`)
};

const es_sci_plot_save_dataset = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Guardar datos`)
};

const de_sci_plot_save_dataset = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Datensatz speichern`)
};

const nl_sci_plot_save_dataset = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dataset opslaan`)
};

const fr_sci_plot_save_dataset = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enregistrer les données`)
};

const it_sci_plot_save_dataset = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Salva dataset`)
};

const pt_br2_sci_plot_save_dataset = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Salvar dados`)
};

const pt_sci_plot_save_dataset = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Guardar dados`)
};

const ja_sci_plot_save_dataset = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`データセットを保存`)
};

const zh_sci_plot_save_dataset = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`保存数据集`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const sci_plot_save_dataset = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.sci_plot_save_dataset(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("sci_plot_save_dataset", locale)
	if (locale === "en") return en_sci_plot_save_dataset(inputs)
	if (locale === "es") return es_sci_plot_save_dataset(inputs)
	if (locale === "de") return de_sci_plot_save_dataset(inputs)
	if (locale === "nl") return nl_sci_plot_save_dataset(inputs)
	if (locale === "fr") return fr_sci_plot_save_dataset(inputs)
	if (locale === "it") return it_sci_plot_save_dataset(inputs)
	if (locale === "pt-BR") return pt_br2_sci_plot_save_dataset(inputs)
	if (locale === "pt") return pt_sci_plot_save_dataset(inputs)
	if (locale === "ja") return ja_sci_plot_save_dataset(inputs)
	return zh_sci_plot_save_dataset(inputs)
};